module.exports = __webpack_public_path__ + "static/media/info.584785ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/info.svg
// module id = 145
// module chunks = 0